/**
 *
 * Disclaimer: Source code mentioned below is(are) Intellectual Property of
 * Crayon Data Holdings Limited (including its subsidiaries and affiliates).
 * Crayon Data Holdings Limited reserves right to own and control it the way
 * it may deem fit. You must refrain from use, access, read, modify, add or
 * delete, sell or use in any other package or programme pertaining to such
 * source code without explicit prior written approval of
 * Crayon Data Holding Limited. Breach of the same shall attract penalty as
 * applicable.
 *
 */

// Redeem Modal
import React, { useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

// import Close from "./Close";
import ModalHeaderImage from "../../assets/img/modal_header.png";
import ScannerImage from "../../assets/img/scanner.png";
import {
  EmailShareButton,
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
  EmailIcon,
  FacebookIcon,
  PinterestIcon,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon
} from "react-share";
import { toTitleCase } from "../../pages/helper";
import { Modal } from "../Modal";
import Icon from "../Icons";
import Image from "../Image";
import Button from "../Button";
import config from "../../service/config";
import uiConfig from "../../uiConfig";
import { checkColor, tobase64 } from "../../service";
// import Color from "color-thief-react";
import { arabicContent } from "../../constants/index";

var MatomoTracker = require('matomo-tracker');
var matomo = new MatomoTracker(config.siteId, config.siteURL);

const ShareModal = ({ size, isModalOpen, hide, item, baseURL }) => {
  const [imgSrc, setImgSrc] = useState("");
  const [textCopied, setTextCopied] = useState(false);
  const currentURL = window.location.href;
  const minWidth = window.innerWidth;
  const lang = localStorage.getItem("language");

  // useEffect(() => {
  //   checkColorImg(item)
  // },[]);
  const checkColorImg = async (item) => {
    let imgSrc = "";
    let imageExists = await checkColor(
      "https://logo.clearbit.com/" + item.url.replace("//", "/") + "?size=800"
    );
    if (imageExists) {
      imgSrc =
        "https://logo.clearbit.com/" +
        item.url.replace("//", "/") +
        "?size=800";
      setImgSrc(imgSrc);
    } else {
      await tobase64(item.image.replace(/%20/g, " "))
        .then((img) => {
          if (img) {
            if (item.image.match(/.(png)$/i)) {
              imgSrc = "data:image/png;base64," + img;
            } else if (item.image.match(/.(jpg)$/i)) {
              imgSrc = "data:image/jpg;base64," + img;
            }
            setImgSrc(imgSrc);
          }
        })
        .catch((err) => {
          imgSrc = item.image;
          setImgSrc(imgSrc);
        });
    }
  };

  const redirectSite = () => {
    hide();
    document.documentElement.style.overflowY = "hidden";
    document.body.style.overflowY = "hidden";
    setTimeout(() => {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-alert">
              <h4 className="text-center">
                {lang === "AR"
                  ? arabicContent.redirectMsg
                  : `By clicking on 'Proceed' you are  providing  consent to  be redirected to the merchant's website and SmartBuy holds no responsibility for any inconveniences or issues incurred hereafter`}
              </h4>
              <div className="custom-alert-button-group">
                <button
                  onClick={() => {
                    matomo.track({
                      url: window.location.href,
                      e_c: item?.url,
                      e_a: 'REDIRECT_MERCHANT',
                      e_n: item?.id
                    });
                    window.open(
                      !item.url ? `${baseURL}` : `${item.url}`,
                      "_blank"
                    );
                    document.documentElement.style.overflowY = "auto";
                    document.body.style.overflowY = "auto";
                    onClose();
                  }}
                >
                  {lang === "AR" ? arabicContent.proceed : `Proceed`}
                </button>
                <button
                  onClick={() => {
                    document.documentElement.style.overflowY = "auto";
                    document.body.style.overflowY = "auto";
                    onClose();
                  }}
                >
                  {lang === "AR" ? arabicContent.cancel : `Cancel`}
                </button>
              </div>
            </div>
          );
        }
      });
    },1)
   
  };
  return (
    // <Modal size={"medium"} isOpen={isModalOpen} hide={hide} style={{marginTop:"100px !important"}}>
    //   <Modal.Content>
    <div className="share-wrap">
      <div className="share-content">
        <div className="share-modal">
          <div
            className={`col-md-12 p-0 header ${
              lang === "AR" ? "header-ar" : ""
            }`}
          >
            <div className="flex justify-between">
              <div className="merchant-details-img-content-mbl-shr">
                <img
                  src={`${config.optimoleURL}/w:320/h:200/q:85/rs:fill/${
                    item?.brandLogo
                      ? item.brandLogo
                      : item?.curatedImage
                      ? item?.curatedImage
                      : item?.image
                  }`}
                  height="100%"
                  width="100%"
                />
              </div>
              {/* <div                
                style={{
                  padding: "0px",
                  backgroundColor: item.dominantColorCode,
                  backgroundImage: item.curatedImage
                    ? `url("https://mlca6kbxnopy.i.optimole.com/w:400/h:400/q:85/rs:fit/${item.brandLogo}")`
                    : `url("https://mlca6kbxnopy.i.optimole.com/w:400/h:400/q:85/rs:fit/${item?.image}")`
                }}
                id={"mycard_" + item.id}
              > */}
              {/* {item.curatedImage ? (
                  <img
                    src={item.curatedImage}
                    style={{
                      minWidth: "180px",
                      maxWidth: "100%",
                      maxHeight: "100%"
                    }}
                    loading="eager"
                  />
                ) : (
                  <img
                    src={"https://logo.clearbit.com/" + item.url + "?size=800"}
                    style={{
                      minWidth: "180px",
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain"
                    }}
                    onError={(e) => {
                      if (item.image) {
                        e.target.onerror = null;
                        e.target.src = item.image.replace(/ /g, "%20");
                      }
                    }}
                    loading="eager"
                  />
                )} */}
              {/* <img src={"https://logo.clearbit.com/"+item.url+"?size=800"} style={{margin:"10px",minWidth:"180px",maxWidth:"100%",maxHeight:"100%",objectFit:'contain'}} onError={(e)=>{e.target.onerror = null; e.target.src=item.image.replace(/ /g, "%20")}} loading="eager"/> */}
              {/* </div> */}
              {/* { <Color 
      src={imgSrc}
      crossOrigin="anonymous" format="hex">
      {({ data, bgLoading }) => {
      if (bgLoading) return <div>{lang === 'AR' ? arabicContent.loading : `loading...`}</div>;
      else
      return(<div className={`merchant-details-img-content-mbl`} style={{padding: "0px",backgroundColor:data?data:uiConfig.config.whitelabel.common_background_color}}   id={"mycard_"+item.id}>
        
     
            
            <img src={"https://logo.clearbit.com/"+item.url+"?size=800"} style={{margin:"10px",minWidth:"180px",maxWidth:"100%",maxHeight:"100%",objectFit:'contain'}} onError={(e)=>{e.target.onerror = null; e.target.src=item.image.replace(/ /g, "%20")}} loading="eager"/>
            
      </div>)}}
      </Color>} */}

              <div
                className={`h-pointer flex-center abs-close ${
                  lang === "AR" ? "abs-close-ar " : ""
                }`}
                onClick={hide}
              >
                <Icon name="cancel" fill="#000" width={10} height={10} />
              </div>
            </div>
            <div className=" flex merchant-name">
              {lang === "AR" ? arabicContent.mername : item.name}
            </div>
            {item.description && (
              <div className="detail">
                {lang === "AR"
                  ? arabicContent.merdesc.slice(0, 180) + "..."
                  : item.description.length > 180 && item.description
                  ? item.description.slice(0, 180) + "..."
                  : item.description}
                {/* <span onClick={()=>redirectSite()} style={{color:uiConfig.config.whitelabel.brandColor}}>
                  {lang === 'AR' ? arabicContent.learnmore : `learn more`}
                </span> */}
              </div>
            )}
            <div className={`desc ${lang === "AR" ? "flex" : ""}`}>
              <span className="item-des">
                {lang === "AR"
                  ? arabicContent.mercate
                  : toTitleCase(item.category)}
              </span>
              <span className="website">
                <a
                  className="website ellipsis"
                  style={{ color: uiConfig.config.whitelabel.brandColor }}
                  onClick={() => {
                    redirectSite();
                  }}
                >
                  {minWidth < 600 && item?.url
                    ? item?.url.slice(0, 20)
                    : item?.url}
                </a>
              </span>
            </div>
          </div>
          <div className="col-md-12 share-body">
            <div className="body-text">
              {lang === "AR"
                ? arabicContent.shareText
                : `Love only grows by sharing, Let your friends and social community know`}
            </div>
            <div className="share-options">
              <div className="share_container">
                <div className="share_button">
                  <EmailShareButton
                    url={" "}
                    subject={item.name}
                    body={
                      item.description
                        ? item.description
                        : item.offers[0].description.length > 180
                        ? item.offers[0].description.slice(0, 180) +
                          "..." +
                          "\n\n" +
                          currentURL
                        : item.offers[0].description + "\n\n" + currentURL
                    }
                  >
                    <EmailIcon size={40} round />
                  </EmailShareButton>
                </div>

                <div className="share_button">
                  <FacebookShareButton
                    url={item.image}
                    hashtag={"#GreatOffersOnHDFCCards"}
                  >
                    <FacebookIcon size={40} round />
                  </FacebookShareButton>
                </div>

                <div className="share_button">
                  <TwitterShareButton
                    url={currentURL}
                    title={
                      item.name +
                      "\n" +
                      (item.description
                        ? item.description
                        : item.offers[0].description.length > 180
                        ? item.offers[0].description.slice(0, 180) + "..."
                        : item.offers[0].description)
                    }
                  >
                    <TwitterIcon size={40} round />
                  </TwitterShareButton>
                </div>

                <div className="share_button">
                  <PinterestShareButton
                    url={item.image}
                    description={
                      item.name +
                      "\n" +
                      (item.description
                        ? item.description
                        : item.offers[0].description.length > 180
                        ? item.offers[0].description.slice(0, 180) +
                          "..." +
                          "\n" +
                          currentURL
                        : item.offers[0].description + "\n" + currentURL)
                    }
                    media={item.image}
                  >
                    <PinterestIcon size={40} round />
                  </PinterestShareButton>
                </div>

                <div className="share_button">
                  <WhatsappShareButton
                    url={currentURL}
                    title={
                      item.name +
                      "\n" +
                      (item.description
                        ? item.description
                        : item.offers[0].description.length > 180
                        ? item.offers[0].description.slice(0, 180) + "..."
                        : item.offers[0].description + "   ")
                    }
                  >
                    <WhatsappIcon size={40} round />
                  </WhatsappShareButton>
                </div>
              </div>
            </div>
            <div className={`copy-div`}>
              <div className="copy-link">
                {lang === "AR" ? arabicContent.copylink : `or copy link`}
              </div>
              <div className="copy-input">
                <span>
                  {minWidth < 600
                    ? currentURL.slice(0, 20)
                    : lang === "AR"
                    ? "..." + currentURL.slice(0, 40)
                    : currentURL.slice(0, 40) + "..."}
                </span>
                <span
                  className={lang === "AR" ? "copy-text-ar" : "copy-text"}
                  onClick={() => {
                    navigator.clipboard.writeText(currentURL);
                    setTextCopied(true);
                  }}
                  style={{ color: uiConfig.config.whitelabel.brandColor }}
                >
                  {textCopied
                    ? lang === "AR"
                      ? arabicContent.copied
                      : `Copied`
                    : lang === "AR"
                    ? arabicContent.copy
                    : `Copy`}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    //   </Modal.Content>
    // </Modal>
  );
};

export default ShareModal;
